import React, { ReactElement } from "react";

import Chip from "@mui/material/Chip";
import Typography from "@mui/material/Typography";

const GenericChip = ({
 text,
 type
}: {
 text: string | ReactElement;
 type: string;
}): ReactElement => {
 const renderStyle = () => {
  switch (type) {
   case "success":
    return {
     color: "#2E7D32",
     border: "1px solid #2E7D32",
     backgroundColor: "rgba(46, 125, 50, 0.2)",
     fontWeight: "bold"
    };
   case "error":
    return {
     color: "#FF1800",
     border: "1px solid #FF1800",
     backgroundColor: "rgb(255, 24, 0, 0.2)",
     fontWeight: "bold"
    };
   case "info":
    return {
     color: "#30D1FF",
     border: "1px solid #30D1FF",
     backgroundColor: "#E0F8FF",
     fontWeight: "bold"
    };
   case "warning":
    return {
     color: "#FFB600",
     border: "1px solid #ffb600",
     backgroundColor: "rgb(255, 182, 0, 0.2)",
     fontWeight: "bold"
    };
   default:
    return {
     color: "#2E7D32",
     border: "1px solid grey",
     backgroundColor: "lightgray",
     fontWeight: "bold"
    };
  }
 };

 return (
  <Chip label={<Typography variant="caption">{text}</Typography>} sx={renderStyle()} size="small" />
 );
};

export default GenericChip;
